import React from 'react';

// Gradient color pairs - vibrant and warm
const GRADIENT_PAIRS = [
  ['#FF6B6B', '#FF8E53'], // Coral to Orange
  ['#4ECDC4', '#556270'], // Teal to Slate
  ['#7C3AED', '#EC4899'], // Purple to Pink
  ['#F59E0B', '#EF4444'], // Amber to Red
  ['#191919', '#3B82F6'], // Green to Blue
  ['#8B5CF6', '#06B6D4'], // Violet to Cyan
  ['#F472B6', '#FB923C'], // Pink to Orange
  ['#2DD4BF', '#A78BFA'], // Teal to Purple
  ['#FBBF24', '#F472B6'], // Yellow to Pink
  ['#191919', '#818CF8'], // Green to Indigo
];

// Generate a consistent gradient based on email or name
const getGradientColors = (identifier) => {
  if (!identifier) return GRADIENT_PAIRS[0];
  
  // Simple hash function
  let hash = 0;
  for (let i = 0; i < identifier.length; i++) {
    const char = identifier.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  
  const index = Math.abs(hash) % GRADIENT_PAIRS.length;
  return GRADIENT_PAIRS[index];
};

const getInitials = (name, email) => {
  if (!name && email) {
    return email[0].toUpperCase();
  }
  if (!name) return 'U';
  const parts = name.trim().split(' ');
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
};

/**
 * GradientAvatar - Displays a colorful gradient avatar with initials
 * @param {string} name - User's name
 * @param {string} email - User's email (fallback for identifier)
 * @param {number} size - Size in pixels (default: 44)
 * @param {string} className - Additional CSS classes
 * @param {object} style - Additional inline styles
 */
const GradientAvatar = ({ name, email, size = 44, className = '', style = {} }) => {
  const identifier = email || name || '';
  const [color1, color2] = getGradientColors(identifier);
  const initials = getInitials(name, email);
  
  const fontSize = Math.max(size * 0.35, 10);
  
  return (
    <div
      className={`flex items-center justify-center rounded-full ${className}`}
      style={{
        width: size,
        height: size,
        background: `linear-gradient(135deg, ${color1} 0%, ${color2} 100%)`,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        flexShrink: 0,
        ...style
      }}
    >
      <span
        style={{
          fontFamily: 'Manrope-Variable, sans-serif',
          fontSize,
          fontWeight: 600,
          color: '#FFFFFF',
          letterSpacing: '0.02em',
          textShadow: '0 1px 2px rgba(0,0,0,0.2)'
        }}
      >
        {initials}
      </span>
    </div>
  );
};

export default GradientAvatar;
